import { ApiService } from "./src/02_utils/apiService";
import { Logger } from "./src/02_utils/logger";
import { Utils } from "./src/02_utils/utils";
import { Filter } from "./src/05_components/filter/filter";
import { ErcasFilter } from "./bundles/ercas-filter/filter";

document.addEventListener('DOMContentLoaded', (event) => {
  const logger = new Logger();
  const utils = new Utils(logger);
  const apiService = new ApiService(logger);

  const filters: NodeListOf<HTMLElement> = document.querySelectorAll('.js-filter');

  filters?.forEach((filter: HTMLElement) => {
    new ErcasFilter(filter, logger, utils);
  });


}, { passive: true });
